/*
 * Copyright (C) Zoomdata, Inc. 2012-2022. All rights reserved.
 */
import { ComponentTypes } from './types';
import { generateUUID } from './utilities';
const defaultElementAttributes = {
    width: '100%',
    height: '100%',
};
const getDefaultLoader = () => {
    const initLoader = document.createElement('div');
    initLoader.id = 'composer-init-loader';
    initLoader.innerHTML = '<div id="composer-init-loader-spinner"></div>';
    return initLoader;
};
export class EmbeddedComponent {
    notificationSettings;
    theme;
    htmlElement;
    componentInstanceId;
    renderer;
    componentType;
    application;
    loader;
    container;
    observerRemoval;
    isSymphonyMode;
    elementAttributes;
    constructor(theme, application, renderer, notificationSettings) {
        this.notificationSettings = notificationSettings;
        this.theme = theme;
        // default to dashboard
        this.componentType = ComponentTypes.DASHBOARD;
        this.componentInstanceId = generateUUID();
        this.renderer = renderer;
        this.application = application || {
            banner: false,
            logo: false,
        };
        this.loader = getDefaultLoader();
        this.elementAttributes = defaultElementAttributes;
        const componentRootElement = document.createElement('div');
        componentRootElement.id = `logi-embed-${this.componentInstanceId}`;
        componentRootElement.className = 'logi-embed';
        const errorMessagesElement = document.createElement('div');
        errorMessagesElement.className = 'embedding-error-messages';
        const themedContainer = document.createElement('div');
        themedContainer.id = `logi-embed-theme-${this.theme || 'default'}`;
        themedContainer.style.height = '100%';
        componentRootElement.appendChild(errorMessagesElement);
        componentRootElement.appendChild(themedContainer);
        this.container = themedContainer;
        this.htmlElement = componentRootElement;
    }
    render(element, attributes) {
        if (attributes) {
            this.elementAttributes = attributes;
        }
        this.addLoader();
        this.addRootClassNames(element);
        this.addRootStyles(this.elementAttributes);
        this.renderer(this, element);
    }
    destroy() {
        //TODO: add specific for component destroy logic
    }
    getApplicationParams() {
        return {
            theme: this.theme,
            application: this.application,
            componentInstanceId: this.componentInstanceId,
            notificationSettings: this.notificationSettings,
        };
    }
    addRootClassNames(element) {
        const embeddedElements = element.querySelectorAll(':scope > div[id^=logi-embed-]');
        if (embeddedElements.length > 0) {
            embeddedElements.forEach((el) => {
                el.classList.remove('logi-embed-main');
            });
        }
        else {
            this.htmlElement.classList.add('logi-embed-main');
        }
    }
    addRootStyles(attributes) {
        const embedStyleElement = document.createElement('style');
        embedStyleElement.innerHTML = `
#logi-embed-${this.componentInstanceId} {
  width: ${attributes.width};
  height: ${attributes.height};
}`;
        this.htmlElement.appendChild(embedStyleElement);
    }
    addLoader() {
        if (this.isSymphonyMode) {
            this.loader.classList.add('platform-style');
        }
        this.htmlElement.appendChild(this.loader);
    }
    removeLoader = () => {
        this.loader.remove();
    };
    addEventListener(eventName, callback) {
        this.htmlElement.addEventListener(eventName, callback);
    }
    removeEventListener(eventName, callback) {
        this.htmlElement.removeEventListener(eventName, callback);
    }
}
//# sourceMappingURL=EmbeddedComponent.js.map